import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';

import AutoSuggestionSelect from '../AutoSuggestionSelect';
import FiltersBar from '../FiltersBar';

import months from '../../utils/months';

class Filters extends PureComponent {
  constructor() {
    super();

    this.state = {
      'q[month_eq]': null,
      'q[employee_first_name_or_employee_last_name_or_employee_email_or_employee_username_cont]': '',
      'q[year_eq]': '',
    };

    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleMonthChange(value) {
    this.setState({ 'q[month_eq]': value });
    this.props.search({
      ...this.state,
      'q[month_eq]': value.value,
    });
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    this.props.search({
      ...this.state,
      [name]: value,
      'q[month_eq]': this.state['q[month_eq]'] ? this.state['q[month_eq]'].value : null,
    });
  }

  render() {
    return (
      <FiltersBar>
        <Grid container alignItems="center" spacing={16}>
          <Grid item xs>
            <TextField
              fullWidth
              placeholder="Nombre, nombre de usuario o email..."
              name="q[employee_first_name_or_employee_last_name_or_employee_email_or_employee_username_cont]"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={3}>
            <AutoSuggestionSelect
              value={this.state['q[month_eq]']}
              options={months}
              placeholder="Mes"
              name="q[month_eq]"
              onChange={this.handleMonthChange}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              type="text"
              placeholder="Año"
              name="q[year_eq]"
              inputProps={{
                maxLength: 4,
                minLength: 4,
              }}
              onChange={this.handleChange}
            />
          </Grid>
        </Grid>
      </FiltersBar>
    );
  }
}

export default Filters;

Filters.propTypes = {
  search: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Paychecks/Filters.js